import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { now } from 'moment';
import { ModalController, NavParams, NavController, PopoverController, Platform } from '@ionic/angular';
import { PickerOptions } from "@ionic/core";
import { NativeService } from "src/app/providers/NativeService";
import { ClipboardService } from "ngx-clipboard";
import {
	DataService,
	AppService,
	LocalStorageService,
	IncidentPopDataService,
	PopDataService,
	MenuService,
	SpaceCheckService,
} from "../../../service";


@Component({
	selector: 'app-version-dialog',
	templateUrl: './version-dialog.component.html',
	styleUrls: ['./version-dialog.component.scss'],
})
export class VersionDialogComponent implements OnInit {
	title = '';
	body = '';
	format = [];
	versionNumber = '';
	updateContent;
	updateUrl;
	latitude = 0;
	longitude = 0;

	android = false;
	ios = false;
	data;
	constructor(
		public appService: AppService,
		public router: Router,
		private nativeService: NativeService,
		public activatedRoute: ActivatedRoute,
		public navCtrl: NavController,
		private platform: Platform,
		public navParams: NavParams,
		private clipboardService: ClipboardService,
		public modalController: ModalController,
		public popoverController: PopoverController) {
		let params = this.navParams.data;
		this.title = params.title;
		this.body = params.body;
		this.format = params.format;
		this.versionNumber = params.versionNumber;
		this.updateContent = params.updateContent;
		this.updateUrl = params.updateUrl;
		this.data = params.data

	}

	ngOnInit() {
		this.android = this.nativeService.isAndroid();
		this.ios = this.nativeService.isIos();

		if (
			document.baseURI.toLowerCase().indexOf("localhost") !== -1 &&
			!this.android &&
			!this.ios
		) {
			// 本地
			this.latitude = null;
			this.longitude = null;
		}

	}

	ionViewWillEnter() {
		document.getElementById('updateContent').innerHTML = this.updateContent;
	}

	async cancel() {
		await this.popoverController.dismiss();
	}

	async delete() {
		await this.popoverController.dismiss('delete');
	}

	async save() {
		await this.popoverController.dismiss('save');
	}

	async confirm() {
		await this.popoverController.dismiss('confirm');
	}

	async submit() {
		await this.popoverController.dismiss('submit');
	}

	async update() {
		await this.popoverController.dismiss('update');
		// if (this.ios) {
		// 	this.platform.ready().then((success) => {
		// 		this.clipboardService.copyFromContent(this.data.downloadUrl.IOS);
		// 		// cordova.InAppBrowser.open(data.downloadUrl.IOS);
		// 		// location.href = data.downloadUrl.IOS;
		// 		// window.open(data.downloadUrl.IOS, '_system', 'location=no');
		// 		// const browser = this.iab.create(data.downloadUrl.IOS);
		// 		// browser.show();
		// 	});
		// 	this.clipboardService.copyFromContent(this.data.downloadUrl.IOS);
		// 	// window.open(data.downloadUrl.IOS, '_system', 'location=no');
		// } else {
		// 	this.clipboardService.copyFromContent(this.data.downloadUrl.Android);
		// 	// cordova.InAppBrowser.open(data.downloadUrl.Android);
		// 	// location.href = data.downloadUrl.Android;
		// 	// window.open(data.downloadUrl.Android, '_system', 'location=no');
		// 	// const browser = this.iab.create(data.downloadUrl.Android);
		// 	// browser.show();
		// }
		// this.appService.toastTipSuccess("下载链接已复制！", false);
		// // await this.popoverController.dismiss('update');
	}
}
